import { FAQPageJsonLd } from 'next-seo'

import { FaqQuestionProps } from '@/types/cms'

function stripUnwantedHtml(html: string): string {
  return html
    .replace(/[\r\n]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/"/g, "'")
    .trim()
    .replace(/<[^>]+>/g, '')
}

export default function FaqData({
  questions
}: {
  questions: FaqQuestionProps[]
}) {
  const faqDataForSEOPurposes = questions?.map((item) => ({
    questionName: stripUnwantedHtml(item.question),
    acceptedAnswerText: stripUnwantedHtml(item.answer)
  }))

  return <FAQPageJsonLd mainEntity={faqDataForSEOPurposes} />
}
